import di from 'di'
import { createRouter, createWebHistory } from 'vue-router'

import Error from '@/js/component/Error.vue'

import Login from '@/js/component/route/Login.vue'
import Player from '@/js/component/route/Player.vue'

import StorageKey from '@/js/enum/StorageKey';

export default function(app){

    const routes = [
        {
            name: 'login',
            path: '/login',
            component: Login,
            meta: {
                authorized: false
            }
        },
        {
            name: 'player',
            path: '/',
            component: Player
        },
        {
            name: 'forbidden',
            path: '/forbidden',
            // props: { mode: ErrorMode.FORBIDDEN },
            component: Error,
            meta: {
                authorized: false
            }
        },
        {
            name: 'error',
            path: '/error',
            component: Error,
            // props: { mode: ErrorMode.NOT_FOUND },
            meta: {
                authorized: false
            }
        },
        {
            path: '/:pathMatch(.*)*',
            component: Error,
            // props: { mode: ErrorMode.NOT_FOUND },
            meta: {
                authorized: false
            }
        }
    ];

    const router = createRouter({
        routes,
        history: createWebHistory(di.get('config').basePath + '/'),
        linkActiveClass: 'active',
    });

    // Auth hook
    router.beforeEach((to, from, next) => {

        if(to.meta.authorized === false){

            next();
            return;
        }

        const code = window.localStorage.getItem(StorageKey.SCREEN_CODE);

        if(!code) {

            next({
                name: 'login',
                query: {
                    path: to.path
                }
            });
        }
        else {
            next();
        }
    });

    di.set('router', router);
    app.use(router);
}